export const streetLightingBadges = {
  startEnd: {
    id: "startEnd",
    type: "startEnd",
    label: "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.START_END",
    key: "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.START_END_HEADER",
    class: "primary"
  },
  intermediate: {
    id: "intermediate",
    type: "intermediate",
    label: "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.INTERMEDIATE",
    key: "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.INTERMEDIATE_HEADER",
    class: "secondary"
  },
  customerSatisfactionSurvey: {
    id: "customerSatisfactionSurvey",
    type: "customerSatisfactionSurvey",
    label: "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.CUSTOMER_SATISFACTION_SURVEY",
    key: "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.CUSTOMER_SATISFACTION_SURVEY_HEADER",
    class: "primary"
  }
};
